import React, { Fragment, useCallback, useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Sidebar from '../components/Sidebar.js';
import { Link } from 'react-router-dom';
import { Form, Modal, Row, Col } from 'react-bootstrap';
import { Button } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Countdown, { zeroPad } from 'react-countdown';

// Chart Components
import DigitalAssets from '../components/dashboard/DigitalAssets.js';
import RevenueChart from '../components/dashboard/RevenueChart.js';
import WithdrawlChart from '../components/dashboard/WithdrawlChart.js';
import MonthlyBarChart from '../components/dashboard/MonthlyBarChart.js';
import TotalRevenue from '../components/dashboard/TotalRevenue.js';
import RecentActivity from '../components/dashboard/RecentActivity.js';
import RecentTransactions from '../components/dashboard/RecentTransactions.js';
import SendQuote from '../components/wallet/Modals/sendQuote.js';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from '../lib/toast.js';
import { getDashboard } from '../api/user.js';
import findTotalBalance from '../lib/findTotalBalance.js';
import isEmpty from 'is-empty';
import moment from 'moment';
import formatStars from '../lib/formatStars.js';

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function Dashboard(props) {
  // Create Quote
  const dispatch = useDispatch();
  const [CreateQuoteshow, setCreateQuoteShow] = useState(false);
  const [data, setData] = useState('');
  const wallet = useSelector((state) => state.wallet);
  const currency = useSelector((state) => state.currency);
  const { totalBalance } = findTotalBalance(wallet, currency);
  const [txType, setTxType] = useState('24');
  const [show, setShow] = useState({ balance: true, inbound: true, outbound: true });

  const handleCreateQuoteClose = () => {
    setCreateQuoteShow(false);
  };
  const handleCreateQuoteShow = () => {
    setCreateQuoteShow(true);
  };

  const renderer = ({ minutes, seconds }) => {
    return (
      <span>
        {minutes}m {seconds}s
      </span>
    );
  };

  const fetchDashboard = useCallback(async () => {
    try {
      let { success, message, result } = await getDashboard();

      if (success) {
        setData(result);
      } else {
        message && toast({ message, type: 'error' }, dispatch);
      }
    } catch (error) {
      toast({ message: 'Some error occurred', type: 'error' }, dispatch);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  const handleShowPortfolio = (id) => {
    setShow((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      <ScrollToTopOnMount />
      <div className="apppage_wrapper">
        <div className="app_page">
          <Navbar />
          <div className="page_wrapper">
            <Sidebar />
            <div className="page_content dashboard_page bg_top">
              <div className="container-fluid">
                <div className="row py-3">
                  <div className="col-md-12 col-lg-8">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="dashbox">
                          <div className="dashtitle_flex mb-1">
                            <h2 className="dash_inner_title">Overview</h2>
                          </div>
                          <p className="dash_inner_subtxt">A summary of your recent transactions and settlements</p>
                          <div className="total_fund_value">
                            <div>
                              <h5>Total Revenue</h5>
                              <div className="d-flex align-items-center">
                                {show.balance ? (
                                  <h3>$ {parseFloat(wallet?.totalInbound?.toFixed(3) || 0).toLocaleString('en-US') || '000.00'}</h3>
                                ) : (
                                  <h3>${formatStars(parseFloat(wallet?.totalInbound?.toFixed(3) || 0))}</h3>
                                )}
                                <i
                                  class={`fa-regular ${show.balance ? 'fa-eye-slash' : 'fa-eye'} ms-2 cursor-pointer`}
                                  onClick={() => handleShowPortfolio('balance')}
                                ></i>
                                {/* <i className="fa-regular fa-eye ms-2 cursor-pointer"></i> */}
                              </div>
                            </div>
                            <div>
                              <h5>Transactions Received</h5>
                              <div className="d-flex align-items-center">
                                <h3>
                                  {show.inbound ? (
                                    <h3>$ {parseFloat(data?.bounds?.transactions?.toFixed(3) || 0).toLocaleString('en-US') || '000.00'}</h3>
                                  ) : (
                                    <h3>${formatStars(parseFloat(data?.bounds?.transactions?.toFixed(3) || 0))}</h3>
                                  )}
                                </h3>
                                <i
                                  class={`fa-regular ${show.inbound ? 'fa-eye-slash' : 'fa-eye'} ms-2 cursor-pointer`}
                                  onClick={() => handleShowPortfolio('inbound')}
                                ></i>
                                {/* <i className="fa-regular fa-eye ms-2 cursor-pointer"></i> */}
                              </div>
                            </div>
                            <div>
                              <h5>Total Withdrawals</h5>
                              <div className="d-flex align-items-center">
                                {show.outbound ? (
                                  <h3>$ {parseFloat(wallet?.totalOutbound?.toFixed(3) || 0).toLocaleString('en-US') || '000.00'}</h3>
                                ) : (
                                  <h3>${formatStars(parseFloat(wallet?.totalOutbound?.toFixed(3) || 0))}</h3>
                                )}

                                <i
                                  class={`fa-regular ${show.outbound ? 'fa-eye-slash' : 'fa-eye'} ms-2 cursor-pointer`}
                                  onClick={() => handleShowPortfolio('outbound')}
                                ></i>
                                {/* <i className="fa-regular fa-eye ms-2 cursor-pointer"></i> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="link_box_panel">
                          <div className="link_box_panel_div">
                            <div className="link_box" onClick={handleCreateQuoteShow}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="25" viewBox="0 0 27 25" fill="none">
                                <path
                                  d="M19.3123 19.061C19.4552 18.996 19.5722 18.944 19.6892 18.8876C20.9651 18.2678 22.2323 17.6306 23.5169 17.0302C24.6434 16.5036 25.8933 17.1364 26.1749 18.3436C26.3742 19.1997 25.9453 20.058 25.0874 20.4828C23.3566 21.3367 21.6193 22.182 19.8841 23.0294C19.1801 23.374 18.4804 23.7294 17.7677 24.0589C16.0932 24.8348 14.3776 24.915 12.6273 24.3276C11.2062 23.8508 9.78515 23.3827 8.36193 22.9124C8.27745 22.8842 8.1908 22.8625 8.10848 22.8408C8.08682 22.8625 8.06299 22.8755 8.06299 22.8907C7.96768 23.6904 7.36113 24.1976 6.41665 24.1781C4.92628 24.1434 3.43591 24.1694 1.94337 24.1694C0.992394 24.1694 0.446502 23.6232 0.444336 22.6696C0.444336 20.5521 0.444336 18.4368 0.444336 16.3193C0.444336 15.3961 0.981563 14.8564 1.90655 14.8542C3.42724 14.8499 4.94794 14.8542 6.47081 14.8542C7.42395 14.8542 7.84853 15.1945 8.05216 16.1199C8.05866 16.1481 8.07166 16.1763 8.09332 16.2348C8.53523 16.2348 8.98581 16.2391 9.43638 16.2348C10.3332 16.2261 11.243 16.1936 12.0965 16.5079C12.8092 16.7701 13.4872 17.1321 14.1869 17.4333C14.3732 17.5135 14.5834 17.5742 14.7848 17.5786C15.5495 17.5959 16.3164 17.6067 17.081 17.5786C18.1685 17.5417 18.9202 17.986 19.3101 19.0632L19.3123 19.061ZM8.09982 17.3857C8.07599 17.4485 8.06299 17.4659 8.06299 17.4854C8.06082 18.7944 8.05433 20.1057 8.06516 21.4147C8.06516 21.4993 8.1908 21.6293 8.28611 21.6618C9.90429 22.208 11.5246 22.7476 13.1493 23.2765C14.5617 23.7359 15.9568 23.6471 17.2933 23.0055C19.7217 21.8374 22.1392 20.641 24.5589 19.4533C25.0181 19.2279 25.1806 18.8074 24.9835 18.4108C24.7863 18.0185 24.3553 17.8993 23.8938 18.1226C22.3645 18.8659 20.8373 19.6115 19.3123 20.3614C19.2104 20.4113 19.113 20.4979 19.0501 20.5911C18.6299 21.2067 18.0515 21.5058 17.3107 21.5058C16.1322 21.5058 14.9538 21.5058 13.7754 21.5058C13.5544 21.5058 13.3313 21.5144 13.1103 21.5036C12.7637 21.4862 12.5363 21.2522 12.5341 20.9292C12.5319 20.6041 12.7572 20.3766 13.106 20.3549C13.2056 20.3484 13.3074 20.3506 13.4071 20.3506C14.696 20.3506 15.9871 20.3506 17.276 20.3506C17.7591 20.3506 18.0818 20.123 18.1707 19.7415C18.2963 19.191 17.9215 18.7424 17.3128 18.7381C16.377 18.7294 15.439 18.7446 14.5032 18.7294C14.2931 18.7251 14.0678 18.6601 13.875 18.5712C13.3183 18.3133 12.7876 18.0012 12.2243 17.7628C10.8943 17.1993 9.48621 17.4463 8.10198 17.3878L8.09982 17.3857ZM6.89539 19.514C6.89539 18.4758 6.89539 17.4377 6.89539 16.3995C6.89539 16.0332 6.86506 16.0051 6.4968 16.0051C4.9956 16.0051 3.4944 16.0051 1.9932 16.0051C1.6141 16.0051 1.59677 16.0202 1.59677 16.3952C1.59677 18.4715 1.60111 20.5478 1.59028 22.6241C1.59028 22.9167 1.68776 23.0164 1.9737 23.0142C3.48573 23.0055 4.9956 23.0055 6.50763 23.0142C6.79574 23.0142 6.89972 22.9124 6.89755 22.6263C6.88672 21.5881 6.89322 20.55 6.89322 19.5118L6.89539 19.514Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M16.3416 16.0767C13.2633 16.0767 10.7808 13.5843 10.7852 10.5002C10.7895 7.42688 13.2915 4.93879 16.3676 4.94312C19.4284 4.94962 21.9196 7.46372 21.9131 10.5413C21.9066 13.5951 19.4068 16.0789 16.3416 16.0767ZM16.3394 14.9215C18.7677 14.9237 20.752 12.9579 20.7628 10.5348C20.7737 8.10309 18.7872 6.09831 16.3567 6.09397C13.9349 6.08964 11.9441 8.07058 11.9398 10.4871C11.9354 12.9362 13.9024 14.9172 16.3416 14.9215H16.3394Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M16.9272 2.27054C16.9272 2.71268 16.9337 3.15481 16.9272 3.59695C16.9185 4.00441 16.678 4.26665 16.3379 4.25582C16.0108 4.24715 15.7725 3.98707 15.7682 3.60128C15.7596 2.71701 15.7596 1.83274 15.7682 0.946303C15.7725 0.547515 16.026 0.278766 16.3618 0.287435C16.691 0.296105 16.9185 0.547515 16.925 0.939801C16.9337 1.38194 16.925 1.82407 16.925 2.26621L16.9272 2.27054Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M14.3582 2.95332C14.3582 3.37595 14.3625 3.79858 14.3582 4.21904C14.3538 4.59399 14.1069 4.85407 13.7755 4.84757C13.4527 4.84107 13.2144 4.58749 13.2122 4.22988C13.2079 3.38462 13.2079 2.54153 13.2122 1.69627C13.2122 1.31916 13.4592 1.06125 13.795 1.06775C14.1221 1.07425 14.3538 1.32132 14.3582 1.68544C14.3647 2.10807 14.3582 2.53069 14.3582 2.95116V2.95332Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M19.4999 2.9945C19.4999 3.4063 19.5042 3.81809 19.4999 4.22988C19.4955 4.59183 19.2616 4.84107 18.9366 4.84757C18.6052 4.85407 18.3539 4.59399 18.3518 4.21904C18.3474 3.37379 18.3453 2.5307 18.3518 1.68544C18.3539 1.32349 18.5944 1.07425 18.9171 1.06775C19.2529 1.06125 19.4955 1.31699 19.4999 1.69627C19.5042 2.12757 19.4999 2.56104 19.4999 2.99234V2.9945Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M18.185 9.13669C18.185 9.46395 18.0009 9.70453 17.7366 9.76521C17.4723 9.8259 17.2145 9.68502 17.0802 9.40327C16.8528 8.93296 16.3372 8.77691 15.8931 9.04782C15.5487 9.25589 15.5357 9.6265 15.8974 9.80422C16.0967 9.90175 16.3394 9.92776 16.5668 9.94943C17.338 10.0253 17.99 10.5346 18.1698 11.2173C18.3648 11.9607 17.9879 12.7149 17.2145 13.0596C17.0001 13.1549 16.9134 13.2589 16.9177 13.4995C16.9264 13.92 16.6903 14.1584 16.335 14.1519C15.9928 14.1454 15.7653 13.907 15.7718 13.5039C15.774 13.2719 15.7177 13.1484 15.4859 13.0596C15.0873 12.9078 14.7948 12.6131 14.615 12.223C14.4612 11.8935 14.5609 11.5684 14.849 11.4167C15.1414 11.2628 15.4425 11.369 15.6375 11.692C15.8823 12.0994 16.4108 12.2251 16.8159 11.9716C17.1452 11.7657 17.1539 11.4167 16.8159 11.2303C16.6643 11.148 16.4758 11.1133 16.3004 11.0981C15.4187 11.0223 14.7515 10.5585 14.5414 9.85407C14.3161 9.09551 14.6995 8.31093 15.4945 7.95983C15.7025 7.8688 15.7783 7.76693 15.774 7.53936C15.7653 7.1189 15.9949 6.87399 16.348 6.87183C16.7011 6.87183 16.9351 7.1124 16.9221 7.53286C16.9134 7.78427 17.0174 7.8753 17.2254 7.96849C17.7517 8.20473 18.0983 8.60136 18.1872 9.13452L18.185 9.13669Z"
                                  fill="#7EC6EF"
                                />
                              </svg>
                              <h2>Create Quote</h2>
                            </div>
                          </div>
                          <div className="link_box_panel_div">
                            <Link to="/transactions" className="link_box">
                              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
                                <path
                                  d="M13.021 0.287963C19.7551 0.287964 25.2119 5.76274 25.2119 12.5049C25.2119 19.2571 19.7402 24.717 12.9813 24.712C6.23479 24.707 0.777961 19.2248 0.7879 12.4677C0.80281 5.73043 6.26958 0.287963 13.021 0.287963ZM13.0111 23.0693C18.858 23.0643 23.5769 18.3351 23.5719 12.4875C23.5644 6.63751 18.8431 1.92319 12.9912 1.92816C7.14426 1.93313 2.42545 6.66236 2.43042 12.5099C2.43787 18.3599 7.16165 23.0743 13.0111 23.0718L13.0111 23.0693Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M8.49404 14.948C9.04817 15.5096 9.56006 16.029 10.0719 16.5484C10.1564 16.6329 10.2434 16.7149 10.3179 16.8068C10.6087 17.1796 10.5789 17.6419 10.2484 17.945C9.91788 18.2482 9.45072 18.2408 9.11029 17.9078C8.66301 17.4729 8.22815 17.028 7.78584 16.5882C7.16959 15.9718 6.55085 15.3605 5.94205 14.7392C5.4898 14.277 5.6215 13.5786 6.19551 13.3674C6.3123 13.3252 6.44648 13.3152 6.57321 13.3152C10.8522 13.3127 15.1312 13.3127 19.4102 13.3152C19.9643 13.3152 20.3196 13.6283 20.3271 14.1154C20.3321 14.6174 19.9767 14.9455 19.4102 14.9455C15.8916 14.948 12.373 14.9455 8.85435 14.9455C8.74998 14.9455 8.64562 14.9455 8.49652 14.9455L8.49404 14.948Z"
                                  fill="#7EC6EF"
                                />
                                <path
                                  d="M17.5092 10.052C17.3999 9.93026 17.3452 9.86067 17.2831 9.79854C16.7786 9.29157 16.2717 8.78709 15.7673 8.28012C15.3995 7.90735 15.3796 7.42274 15.7126 7.08228C16.0531 6.73436 16.5451 6.75672 16.9302 7.13944C17.9565 8.16332 18.9778 9.18968 20.0065 10.2086C20.2873 10.4869 20.414 10.7976 20.2625 11.1753C20.1109 11.5531 19.8052 11.6897 19.4077 11.6897C15.1262 11.6848 10.8472 11.6897 6.56573 11.6873C6.10105 11.6873 5.76808 11.4387 5.69105 11.0511C5.61153 10.651 5.81529 10.2484 6.193 10.1191C6.35203 10.0645 6.53343 10.057 6.70737 10.057C10.1713 10.0545 13.6377 10.0545 17.1017 10.0545L17.5117 10.0545L17.5092 10.052Z"
                                  fill="#7EC6EF"
                                />
                              </svg>
                              <h2>Transactions</h2>
                            </Link>
                          </div>
                          <div className="link_box_panel_div">
                            <Link to="/wallet" className="link_box">
                              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                                <path
                                  d="M4.55784 5.91401H3.78613C2.40542 5.91401 1.28613 7.0333 1.28613 8.41401V20.529C1.28613 21.9097 2.40542 23.029 3.78613 23.029H18.4164C19.7971 23.029 20.9164 21.9097 20.9164 20.529V8.09515C20.9164 6.89054 19.9398 5.91401 18.7352 5.91401V5.91401M4.55784 5.91401L14.9424 1.99173C16.3676 1.45343 17.9388 2.30415 18.267 3.79185L18.7352 5.91401M4.55784 5.91401H18.7352"
                                  stroke="#7EC6EF"
                                />
                                <path
                                  d="M19.5751 12H14.7029C13.338 12 12.2314 13.1065 12.2314 14.4715C12.2314 15.8364 13.338 16.9429 14.7029 16.9429H19.5751C20.94 16.9429 22.0466 15.8364 22.0466 14.4715C22.0466 13.1065 20.94 12 19.5751 12Z"
                                  stroke="#7EC6EF"
                                />
                              </svg>
                              <h2>Wallet</h2>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                      
                   

                 
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="dashbox">{!isEmpty(data) && <DigitalAssets data={data} />}</div>
                      </div>
                    </div>

                    <div className="row dashbox_fullheight_row">
                      <div className="col-lg-6 col-md-6">
                        <div className="dashbox dashbox_fullheight dashbox_small_pad">
                          <div className="dashtitle_flex mb-1">
                            <h2 className="dash_inner_title dash_inner_title_small">Past 24 Hours</h2>
                            <div class="btn-group btn-group_custom" role="group" aria-label="Basic example">
                              <button type="button" class={`grp_btn ${txType === '72' ? 'active' : ''}`} onClick={() => setTxType('72')}>
                                72hrs
                              </button>
                              <button type="button" class={`grp_btn ${txType === '48' ? 'active' : ''}`} onClick={() => setTxType('48')}>
                                48hrs
                              </button>
                              <button type="button" class={`grp_btn ${txType === '24' ? 'active' : ''}`} onClick={() => setTxType('24')}>
                                24hrs
                              </button>
                            </div>
                          </div>
                          {data?.timelineRevenue && (
                            <div className="hrs_chart_flex">
                              {txType == '72' ? (
                                <Fragment>
                                  <RevenueChart data={data.timelineRevenue.past72} />
                                  <WithdrawlChart data={data.timelineRevenue.past72} />
                                </Fragment>
                              ) : txType == '48' ? (
                                <Fragment>
                                  <RevenueChart data={data.timelineRevenue.past48} />
                                  <WithdrawlChart data={data.timelineRevenue.past48} />
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <RevenueChart data={data.timelineRevenue.past24} />
                                  <WithdrawlChart data={data.timelineRevenue.past24} />
                                </Fragment>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="dashbox dashbox_fullheight dashbox_small_pad">
                          <div className="dashtitle_flex mb-1">
                            <h2 className="dash_inner_title dash_inner_title_small">
                              {moment(new Date(new Date().setMonth(new Date().getMonth() - 1))).format('MMMM')} Revenue
                            </h2>
                          </div>
                          <div className="hrs_chart_flex">
                            {data?.monthlyRevenue && <TotalRevenue data={data.monthlyRevenue} />}
                            <div className='custom_tooltip' >
                            {data?.monthlyRevenue && <MonthlyBarChart data={data.monthlyRevenue} />}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-4">
                    <div className="row">
                      <div className="col-lg-12">
                        <RecentTransactions />
                      </div>
                      <div className="col-lg-12">
                      <RecentActivity />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Create Quote Modal */}
      {CreateQuoteshow && <SendQuote showSendQuote={CreateQuoteshow} handleCloseSendQuote={handleCreateQuoteClose} />}
    </>
  );
}
